import types from './types'

export const toggleView = newView => dispatch => {
    dispatch({ type: types.TOGGLE_VIEW, payload: newView })
};

export const resetView = () => dispatch => {
    dispatch({ type: types.RESET_VIEW })
}